<template>
    <v-card class="v-flex p-0" flat style="border-radius: unset" @click="onClick"  >
        <div class="measure-name primary white--text">
            {{ name }}
        </div>
        <div class="measure-value secondary lighten-4 secondary--text">
            {{ measure }}
        </div>
    </v-card>
</template>

<script>

export default {
    name: "PIncMeasureCard",

    props: {
        id: {

        },

        name: {

        },

        measure: {

        }
    },

    methods: {
        onClick () {
            this.$emit("click", this.id)
        }
    }
}

</script>

<style scoped>

.measure-name {
    width: 50%;
    /* Matches PLgsMeasureCard's min-height so cards look consistent across groups regardless of
       whether they carry an optional hint line. */
    min-height: 34px;
    text-align: left;
    padding-left: 10px;
    padding-top: 3px;
    font-size: 16px;
    border-bottom-left-radius: 6px;
    margin-right: 0;
    display: flex;
    align-items: center;
}

.measure-value {
    width: 50%;
    text-align: center;
    padding-top: 6px;
    flex: 1 1 auto;
    font-size: 22px;
    font-weight: 600;
    border-bottom-left-radius: 6px!important;
    border-bottom-right-radius: 6px!important;
    display: flex;
    align-items: center;
    justify-content: center;
}

</style>